import type { PixelLogger } from './PixelLogger';

export class ConsolePixelLogger implements PixelLogger {
  constructor(private readonly debugEnabled: boolean) {}

  debug(...args: unknown[]): void {
    if (!this.debugEnabled) return;
    if (typeof console === 'undefined') return;
    console.debug(...args);
  }

  info(...args: unknown[]): void {
    if (typeof console === 'undefined') return;
    console.info(...args);
  }

  warn(...args: unknown[]): void {
    if (typeof console === 'undefined') return;
    console.warn(...args);
  }

  error(...args: unknown[]): void {
    if (typeof console === 'undefined') return;
    console.error(...args);
  }
}
